import { connect } from 'react-redux';
import Global from '../../../../store/global-selectors';
import * as Actions from '../../../../store/orders/filtering/orders.filtering.actions';
import { orderGridChangePage } from '../../../../store/orders/grid/orders.grid.actions';
import FilterView from '../index';

const mapStateToProps = (state, ownProps) => {
  const activeFilterViewId = Global.selectOrdersFilteringActiveFilterViewId(state);
  return {
    isActive: activeFilterViewId === ownProps.filterViewId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onViewClick: (filterViewId) => {
      dispatch(orderGridChangePage(1));
      dispatch(Actions.switchActiveFilterView(filterViewId));
    },
    launchEditViewModal: () => {
      dispatch(Actions.launchEditViewModal());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterView);
